import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'

import {EquipmentDto, KpisQueryKey} from '../../types'

const QueryKeyPrefix = KpisQueryKey.RunningTimesPlantEquipments

type Options<TSelect> = Omit<
  UseQueryOptions<EquipmentDto[], AxiosError, TSelect>,
  'queryKey' | 'queryFn'
> & {
  onError?: (error: AxiosError) => void
}

export const usePlantEquipments = <TSelect = EquipmentDto[]>(
  plantId: string,
  options?: Options<TSelect>
) => {
  const query = useQuery<EquipmentDto[], AxiosError, TSelect>({
    queryKey: [QueryKeyPrefix, plantId],
    queryFn: async ({signal}) => {
      const path = `/kpi/runningtimes/${plantId}/equipments`
      const response = await ApiClient.axiosInstance.get<EquipmentDto[]>(path, {signal})

      return response.data
    },
    ...options
  })

  const onError = options?.onError
  useEffect(() => {
    if (query.error) {
      onError?.(query.error)
    }
  }, [query.error, onError])

  return query
}
